module.exports = __webpack_public_path__ + "static/media/er.c828c446.png";